import React from 'react';
import '../../styles/components/AsperaAppSwitcher.scss';
import { withRouter } from 'react-router-dom';
import { language } from '../../services/LanguageService';
import { Button, getIconComponent, HeaderPanel, Switcher, SwitcherItem, Tag } from '../Carbon';
import { SubManager } from '../../classes/SubManager';
import { modal } from '../../services/ModalService';
import { ModalFormRender } from '../../components/ModalFormRender';
import { getEnvironmentVar } from '../../helpers/helpers';
import { tracking } from '../../services/TrackingService';
import { Subject } from 'rxjs';
/**
 * React Component
 *
 * The AsperaAppSwitcher renders the app switcher for the right nav item
 *
 * @example
 * ```javascript
 * <AsperaAppSwitcher apps={[]} changeApp={() => {}} currentApp={{}} />
 * ```
 */
export const AsperaAppSwitcher = withRouter(class AsperaAppSwitcher extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
        this.changeDefaultApp = () => {
            var _a;
            const { changeDefaultApp, apps } = this.props;
            const modalInfo = modal.prepare();
            const disableSubject = new Subject();
            const modalProps = {
                modalHeading: language.get('header.defaultViewHeader'),
                primaryButtonText: language.get('header.save'),
                size: 'sm',
            };
            const formModel = {
                defaultApp: (_a = apps.find(item => item.default)) === null || _a === void 0 ? void 0 : _a.id,
            };
            const formProps = {
                id: 'default-app-modal-chooser',
                model: formModel,
                items: [
                    {
                        type: 'sub-header',
                        label: language.get('header.defaultViewLabel', [getEnvironmentVar('app_name')]),
                    },
                    {
                        type: 'radio',
                        radioProps: {
                            orientation: 'vertical',
                        },
                        required: true,
                        pointer: 'defaultApp',
                        items: apps.filter(item => !!item.id).map(item => {
                            return {
                                text: item.displayName,
                                value: item.id,
                            };
                        }),
                    },
                ],
            };
            this.subManager.setSubscription(modal.create(modalInfo.id, modalProps, React.createElement(ModalFormRender, { disableSubject: disableSubject, className: "change-default-app-modal", formData: formProps, modalClose: modalInfo.callback }), disableSubject.asObservable()).subscribe({
                next: () => {
                    if (typeof changeDefaultApp === 'function' && formModel.defaultApp) {
                        changeDefaultApp(formModel.defaultApp);
                    }
                },
                error: () => { },
            }));
        };
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className, apps, changeApp, currentApp, changeDefaultApp } = this.props;
        return (React.createElement(HeaderPanel, { className: `aspera-app-switcher ${className ? className : ''}`, "aria-label": language.get('header.appSwitcher'), expanded: true },
            React.createElement(Switcher, { "aria-label": language.get('header.appSwitcher') },
                apps.map((app, index) => {
                    return (React.createElement(SwitcherItem, { key: index, "aria-label": app.displayName, className: `app-item ${currentApp.id === app.id ? 'current' : ''}`, "data-auto": `header-app-list-item-${app.route}`, onClick: (event) => {
                            if (currentApp.route !== app.route) {
                                tracking.checkDirtyForms(() => changeApp(app.route, event));
                            }
                        } },
                        React.createElement("div", { className: "app-switcher-icon" }, React.createElement(app.icon)),
                        React.createElement("div", { className: "app-switcher-info" },
                            React.createElement("div", { className: "app-switcher-name" }, app.displayName),
                            React.createElement("div", { className: "app-switcher-description" }, app.description),
                            !!(app.default && apps.length > 1) && React.createElement(Tag, { type: "warm-gray", className: "app-switcher-default" }, language.get('header.default')))));
                }),
                !!(changeDefaultApp && apps.length > 1) && React.createElement(Button, { kind: "tertiary", className: "app-switcher-change-button", size: "sm", onClick: this.changeDefaultApp, renderIcon: getIconComponent('ArrowRight', 20) }, language.get('header.changeDefaultApp')))));
    }
});
